import { useMemo } from 'react'
import { UnitLabel } from '@/shared/config/config'
import { useTranslation } from 'react-i18next'
import { CarbonTaxPaidRaw } from '@/api/EmissionReportModel'
import { EuroCoinIcon } from '@/common/components/icons'
import { DataBlock, GenericDialog } from '@/common'
import ReportSectionCard from '../ReportSectionCard'
import CarbonTaxPaidReporting from './CarbonTaxPaidReporting'
import useDialog from '@/common/hooks/useDialog'

export default function CarbonTaxPaidSection({
  carbonTaxPaid,
  isComplete,
  isViewMode,
  reportId
}: {
  carbonTaxPaid: CarbonTaxPaidRaw | null
  isComplete: boolean
  isViewMode: boolean
  reportId: string
}) {
  const { t } = useTranslation()
  const { open, openDialog, closeDialog } = useDialog()

  const {
    effectiveCarbonPriceDue,
    currency,
    carbonPriceMechanismId,
    embeddedEmissionsCovered,
    embeddedEmissionsCoveredByRebate
  } = useMemo(() => {
    return {
      effectiveCarbonPriceDue: carbonTaxPaid?.effectiveCarbonPriceDue || '',
      currency: carbonTaxPaid?.currency || '',
      carbonPriceMechanismId: carbonTaxPaid?.carbonPriceMechanismId || '',
      embeddedEmissionsCovered: carbonTaxPaid?.embeddedEmissionsCovered || '',
      embeddedEmissionsCoveredByRebate: carbonTaxPaid?.embeddedEmissionsCoveredByRebate || ''
    }
  }, [carbonTaxPaid])
  return (
    <>
      <div>
        <ReportSectionCard
          icon={<EuroCoinIcon className="size-4" />}
          isOptional={false}
          title={t('report:carbonTaxPaid.title')}
          reportButtonText={t('report:carbonTaxPaid.reportButtonText')}
          onEdit={openDialog}
          isComplete={isComplete}
          completionPercentage={isComplete ? 100 : 0}
          isViewMode={isViewMode}
        >
          {carbonPriceMechanismId ? (
            <div className="grid grid-cols-2 gap-2 lg:grid-cols-4">
              <DataBlock
                label={t('report:carbonTaxPaid.fields.effectiveCarbonPriceDue.label')}
                data={`${effectiveCarbonPriceDue} ${currency}`}
              />
              <DataBlock
                label={t('report:carbonTaxPaid.fields.carbonPriceMechanism.label')}
                data={t(`common:carbonPriceMechanisms.${carbonPriceMechanismId}`)}
              />
              <DataBlock
                label={t('report:carbonTaxPaid.fields.embeddedEmissionsCovered.label')}
                data={`${embeddedEmissionsCovered} ${UnitLabel.tCO2e}`}
              />
              <DataBlock
                label={t('report:carbonTaxPaid.fields.embeddedEmissionsCoveredByRebate.label')}
                data={`${embeddedEmissionsCoveredByRebate} ${UnitLabel.tCO2e}`}
              />
            </div>
          ) : (
            <h3 className="font-semibold">{t('report:carbonTaxPaid.notPaid')}</h3>
          )}
        </ReportSectionCard>
      </div>
      <GenericDialog
        title={t('report:carbonTaxPaid.title')}
        isOpen={open}
        close={closeDialog}
        size="2xl"
      >
        <CarbonTaxPaidReporting
          close={closeDialog}
          initialValue={carbonTaxPaid}
          reportId={reportId}
        />
      </GenericDialog>
    </>
  )
}
